import React from "react";
import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";

export interface BlockingLoaderProps {
  open: boolean;
  message?: string;
}

export const BlockingLoader = ({ open, message }: BlockingLoaderProps) => {
  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.modal + 1,
      }}
      open={open}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        <CircularProgress color="inherit" />
        {message ? (
          <Typography variant="h6" component="div" sx={{ textAlign: "center" }}>
            {message}
          </Typography>
        ) : null}
      </Box>
    </Backdrop>
  );
};
